import * as type from "../types";

export function getSessionRequested(payload) {
  return {
    type: type.GET_SESSION_REQUESTED,
    payload: payload,
  };
}

export function getSessionFailed() {
  return {
    type: type.GET_SESSION_FAILED,
  };
}

export function getSessionsRequested() {
  return {
    type: type.GET_SESSIONS_REQUESTED,
  };
}
export function getSessionsSucceeded(data) {
  return {
    type: type.GET_SESSIONS_SUCCEEDED,
    payload: data,
  };
}
export function getSessionsFailed() {
  return {
    type: type.GET_SESSIONS_FAILED,
  };
}

export function getSimplifiedSessionsRequested() {
  return {
    type: type.GET_SIMPLIFIED_SESSIONS_REQUESTED,
  };
}
export function getSimplifiedSessionsSucceeded(data) {
  return {
    type: type.GET_SIMPLIFIED_SESSIONS_SUCCEEDED,
    payload: data,
  };
}
export function getSimplifiedSessionsFailed() {
  return {
    type: type.GET_SIMPLIFIED_SESSIONS_FAILED,
  };
}

export function getCurrentSessionsRequested() {
  return {
    type: type.GET_CURRENT_SESSIONS_REQUESTED,
  };
}
export function getCurrentSessionsSucceeded(data) {
  return {
    type: type.GET_CURRENT_SESSIONS_SUCCEEDED,
    payload: data,
  };
}
export function getCurrentSessionsFailed() {
  return {
    type: type.GET_CURRENT_SESSIONS_FAILED,
  };
}

export function setCurrentContracts(data) {
  return {
    type: type.SET_CURRENT_CONTRACTS,
    payload: data,
  };
}
export function removeCurrentContracts(data) {
  return {
    type: type.REMOVE_CURRENT_CONTRACTS,
    payload: data,
  };
}

export function setSelectedSessionContracts(data) {
  return {
    type: type.SET_SELECTED_SESSION_CONTRACTS,
    payload: data,
  };
}

export function contractSelect(data) {
  return {
    type: type.SET_CURRENT_CONTRACT_SELECTED,
    payload: data,
  };
}
export function getContractDepthRequested(filter) {
  return {
    type: type.GET_CONTRACT_DEPTH_REQUESTED,
    payload: filter,
  };
}
export function getContractDepthSucceeded(data) {
  return {
    type: type.GET_CONTRACT_DEPTH_SUCCEEDED,
    payload: data,
  };
}
export function getContractDepthFailed() {
  return {
    type: type.GET_CONTRACT_DEPTH_FAILED,
  };
}
